import FestivalHero from "../common/hero";
import PercentageFestivalDefault from "./default";
import PercentageFestivalAllProduct from "./AllProduct";
import FestivalFooter from "../common/footer";
import { FESTIVAL_TYPE, FestivalProps } from "@features/landing/types";

const PercentageFestival: React.FC<FestivalProps> = ({ festivalData }) => {
  const festival = festivalData?.data.festival;
  if (!festival) return null;

  const theme = festival.type || FESTIVAL_TYPE.PERCENT;
  const expireTime = festival.time_period.expire_at || 0;
  const footerDescription = festival.footer_description || "";
  const allProduct = festival.is_all_products_included;
  const title = festival.title || "";
  const specialText = festival.special_text || "";
  const discountText = festival.discount_text || "";

  return (
    <>
      <FestivalHero
        title={title}
        theme={theme}
        expireDate={expireTime}
        discountText={discountText}
        specialText={specialText}
      />
      {allProduct ? (
        <>
          <PercentageFestivalAllProduct />
          {footerDescription ? (
            <FestivalFooter theme={theme} description={footerDescription} />
          ) : null}
        </>
      ) : (
        <PercentageFestivalDefault festivalData={festivalData} />
      )}
    </>
  );
};

export default PercentageFestival;
